import { FetchTransport, type AccessTokenProvider, type Transport } from './transport';

export type ApiMode = 'http' | 'fixture';

/**
 * fixtureは開発・テストで明示的に選ぶものとし、既定はhttp。
 * API障害時に自動でfixtureへ切り替える経路は作らない。
 */
export function resolveApiMode(raw: string | undefined = import.meta.env.VITE_API_MODE): ApiMode {
  return raw === 'fixture' ? 'fixture' : 'http';
}

/** authは実APIへ送るときだけ使う。fixtureはin-memoryで完結するので受け取っても渡さない。 */
export async function createTransport(
  mode: ApiMode,
  auth?: AccessTokenProvider,
): Promise<Transport> {
  if (mode === 'fixture') {
    const { createFixtureTransport } = await import('../fixtures/transport');
    return createFixtureTransport();
  }
  return new FetchTransport(apiBase(), auth);
}

/**
 * 空なら同一オリジン（localはvite dev serverのproxyが受ける）。静的配信ではAPIが別オリジンなので
 * ビルド時にVITE_API_BASEで埋める。末尾の / はpathの先頭と重なって // になるので落とす。
 */
function apiBase(raw: string | undefined = import.meta.env.VITE_API_BASE): string {
  return (raw ?? '').replace(/\/+$/, '');
}
